import { render, staticRenderFns } from "./AuxiliaryAccountingDetail.vue?vue&type=template&id=da612cd8&scoped=true"
import script from "./AuxiliaryAccountingDetail.vue?vue&type=script&lang=js"
export * from "./AuxiliaryAccountingDetail.vue?vue&type=script&lang=js"
import style0 from "./AuxiliaryAccountingDetail.vue?vue&type=style&index=0&id=da612cd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da612cd8",
  null
  
)

export default component.exports